<template>
  <el-footer>
    <div class="edu-footer">
      Copyright © 2021 广东省建设工程质量安全检测和鉴定协会 All Rights Reserved. ICP备案号：<a style="color: #FFFFFF;text-decoration:none;" href="http://www.beian.miit.gov.cn/">粤ICP备19106570号-1</a>
       <br/>广州市华软科技发展有限公司技术支持
    </div>
  </el-footer>
</template>

<script>
  export default {
    name: "EduFoot"
  }
</script>

<style scoped>
  .el-footer {
    padding: 0px;
    position: absolute;
    bottom: 0px;
    min-width: 1200px;
    width: 100%;
    height: 96px !important;
  }
  .edu-footer{
    text-align: center;
    padding-top: 38px;
    padding-bottom: 37px;
    color: #FFFFFF;
    background: rgb(102, 177, 255);
    font-size: 14px;
  }
</style>
